import React,{useState,useRef,useEffect} from 'react'
import {InputText} from 'primereact/inputtext'
import {FAQS_QUESTIONS} from '../../../constants'
import './FAQs.css';


const FAQs = () => {

  const [search,setSearch] = useState('')
  const [activeIndex,setActiveIndex] = useState(null)
  const [suggestions,setSuggestions] = useState()
  const [defaultLoginURL] = useState('/accountmanagement/auth/my-profile')
  
  const [backurl, setBackUrl] = useState(null)
  const [appname,setAppName] = useState(null)
  useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search)
        const backbtnurl = queryParams.get("backbtnurl")
        const appnameparam = queryParams.get("appname")
        const loginparam = queryParams.get("login")
        if (backbtnurl !== null && backbtnurl !== '') { 
          setBackUrl(`${backbtnurl.replace('/login.html','')}/oauth2/authorization/oracle`)
        }
        if (appnameparam !== null && appnameparam !== '') {
          setAppName(appnameparam)
        }
  }, [])

  const [questions,setQuestions] = useState(FAQS_QUESTIONS)
  return <div>
    <div className="faqs-back" onClick={()=>{
      console.log(backurl)
      window.location.href = backurl||defaultLoginURL;
    }}><i className="pi pi-chevron-left"></i><span>Back</span></div>
    <div className="activate-account-card">
    <div className="center">
      <div className="big-title">Frequently Ask Questions</div>
      <div style={{height:'20px'}}></div>
      <div className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={search} onChange={(e) => {
                        setSearch(e.target.value)
                        setActiveIndex(null)
                        }} placeholder="Search keywords or questions" />
                    <div>{JSON.stringify(suggestions)}</div>
      </div>
      <div style={{height:'28px'}}></div>

    {
        questions.filter(item=>item.question.toLowerCase().indexOf(search.toLocaleLowerCase())>-1).length ===0 ? <div>No FQAs found, please try with a different question.</div> : null 
    }
      {questions.filter(item=>item.question.toLowerCase().indexOf(search.toLocaleLowerCase())>-1).filter(item=>item.category==="Login/Authorization").length >0 ? <div className="faqs-section">
        <div className="faqs-section-header">Login/Authorization</div>
      {questions.filter(item=>item.question.toLowerCase().indexOf(search.toLocaleLowerCase())>-1).filter(item=>item.category==="Login/Authorization").map((item,index)=>{
        return <div className="faqs-container" key={index}>
                <div className="faqs-header" onClick={()=>{
                    if(item.question===activeIndex){
                        setActiveIndex(null)
                    }else{
                        setActiveIndex(item.question)
                    }
                }}><div className="faqs-question">{item.question}</div><div className="faqs-icon"><i className={item.question!==activeIndex ? "pi pi-chevron-down" : "pi pi-chevron-up"} /></div></div>
                <div className={item.question!==activeIndex ? "hide-answer" :"faqs-answer"} dangerouslySetInnerHTML={{ __html: item.answer }} >
                
                </div>
                <hr/>
            </div>
      })}
      </div>:null}

      <div>{JSON.stringify()}</div>
      {questions.filter(item=>item.question.toLowerCase().indexOf(search.toLocaleLowerCase())>-1).filter(item=>item.category==="Account Activation").length >0 ? <div className="faqs-section">
        <div className="faqs-section-header">Account Activation</div>
      {questions.filter(item=>item.question.toLowerCase().indexOf(search.toLocaleLowerCase())>-1).filter(item=>item.category==="Account Activation").map((item,index)=>{
        return <div className="faqs-container" key={index}>
                <div className="faqs-header" onClick={()=>{
                    if(item.question===activeIndex){
                        setActiveIndex(null)
                    }else{
                        setActiveIndex(item.question)
                    }
                }}><div className="faqs-question">{item.question}</div><div className="faqs-icon"><i className={item.question!==activeIndex ? "pi pi-chevron-down" : "pi pi-chevron-up"} 
                /></div></div>
                <div className={item.question!==activeIndex ? "hide-answer" :"faqs-answer"} dangerouslySetInnerHTML={{ __html: item.answer }} >
                
                </div>
                <hr/>
            </div>
      })}
      </div>:null}


      {questions.filter(item=>item.question.toLowerCase().indexOf(search.toLocaleLowerCase())>-1).filter(item=>item.category==="Two-Step Verification").length > 0 ?<div className="faqs-section">
        <div className="faqs-section-header">Two-Step Verification</div>
      {questions.filter(item=>item.question.toLowerCase().indexOf(search.toLocaleLowerCase())>-1).filter(item=>item.category==="Two-Step Verification").map((item,index)=>{
        return <div className="faqs-container" key={index}>
                <div className="faqs-header" onClick={()=>{
                    if(item.question===activeIndex){
                        setActiveIndex(null)
                    }else{
                        setActiveIndex(item.question)
                    }
                }}><div className="faqs-question">{item.question}</div><div className="faqs-icon"><i className={item.question!==activeIndex ? "pi pi-chevron-down" : "pi pi-chevron-up"} /></div></div>
                <div className={item.question!==activeIndex ? "hide-answer" :"faqs-answer"} dangerouslySetInnerHTML={{ __html: item.answer }} >
                
                </div>
                <hr/>
            </div>
      })}
      </div>:null}

      {questions.filter(item=>item.question.toLowerCase().indexOf(search.toLocaleLowerCase())>-1).filter(item=>item.category==="Account Management").length>0 ? <div className="faqs-section">
        <div className="faqs-section-header">Account Management</div>
      {questions.filter(item=>item.question.toLowerCase().indexOf(search.toLocaleLowerCase())>-1).filter(item=>item.category==="Account Management").map((item,index)=>{
        return <div className="faqs-container" key={index}>
                <div className="faqs-header" onClick={()=>{
                    if(item.question===activeIndex){
                        setActiveIndex(null)
                    }else{
                        setActiveIndex(item.question)
                    }
                }}><div className="faqs-question">{item.question}</div><div className="faqs-icon"><i className={item.question!==activeIndex ? "pi pi-chevron-down" : "pi pi-chevron-up"} /></div></div>
                <div className={item.question!==activeIndex ? "hide-answer" :"faqs-answer"} dangerouslySetInnerHTML={{ __html: item.answer }} >
                
                </div>
                <hr/>
            </div>
      })}
      </div>:null}
        
    </div>
</div>
</div>
}

export default FAQs